wbApp.filter('emailGroupStatus', ['$translate', function ($translate) {
    return function (input) {
        switch (input) {
            case 0:
                return $translate.instant('TXT_EMAIL_GROUP_PROCESSING');
            case 1:
                return $translate.instant('TXT_EMAIL_GROUP_ALL_DELIVERED');
            case 2:
                return $translate.instant('TXT_EMAIL_GROUP_PARTIALLY_DELIVERED');
            case 3:
                return $translate.instant('TXT_EMAIL_GROUP_NOT_DELIVERED');
            default:
                return '';
        }
    };
}]);

wbApp.filter('emailStatus', ['$translate', function ($translate) {
    return function (input) {
        switch (input) {
            case 0: // NotSentToSendgridWillRetry
                return $translate.instant('TXT_EMAIL_NOT_SENT_TO_GW_WILL_RETRY');
            case 1: // NotSentToSendgridWillNotRetry
                return $translate.instant('TXT_EMAIL_NOT_SENT_TO_GW_WILL_NOT_RETRY');
            case 2: // SentToSendGrid
                return $translate.instant('TXT_EMAIL_NOT_SENT_TO_GW');
            case 3: // Processed
                return $translate.instant('TXT_EMAIL_PROCESSED');
            case 4: // Dropped
                return $translate.instant('TXT_EMAIL_DROPPED');
            case 5: // Delivered
                return $translate.instant('TXT_EMAIL_DELIVERED');
            case 6: // Deferred
                return $translate.instant('TXT_EMAIL_DEFERRED');
            case 7: // Bounce
                return $translate.instant('TXT_EMAIL_BOUNCE');
            default:
                return 'Unknown';
        }
    };
}]);


